import generatedCustomFunctionPresets from "./generatedCustomFunctionPresets.json";

export const CUSTOM_FUNCTION_ACTION_CODE = 33;
export const CUSTOM_FUNCTION_UNKNOWN_PRESET_ID = "__unknown_custom_function__";

const PRESET_LABELS = {
  reboot_piab: "Reboot PiAB",
};

function defaultLabelFromId(id = "") {
  return id
    .split(/[_-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export const customFunctionPresets = generatedCustomFunctionPresets.map(
  (preset) => {
    const id = preset.id || "";

    return {
      id,
      label: PRESET_LABELS[id] || defaultLabelFromId(id),
      filename: preset.filename || "",
      script: preset.script || "",
      vars: preset.vars || {},
      sourceFile: preset.sourceFile || "",
    };
  },
);

const presetById = new Map(
  customFunctionPresets.map((preset) => [preset.id, preset]),
);
const presetByFilename = new Map(
  customFunctionPresets.map((preset) => [preset.filename, preset]),
);

function encodeBase64(text) {
  if (typeof btoa === "function") {
    return btoa(text);
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(text, "utf8").toString("base64");
  }
  throw new Error("No base64 encoder available");
}

export function getCustomFunctionPresetOptions() {
  return customFunctionPresets.map((preset) => ({
    label: preset.label,
    value: preset.id,
  }));
}

export function getCustomFunctionPresetById(presetId) {
  return presetById.get(presetId) || null;
}

export function getCustomFunctionPresetByFilename(filename) {
  return presetByFilename.get(filename) || null;
}

export function encodeCustomFunctionPresetById(presetId) {
  const preset = getCustomFunctionPresetById(presetId);
  if (!preset) {
    return "";
  }

  return encodeBase64(preset.script.replace(/\r\n?/g, "\n"));
}

export function getCustomFunctionPresetLabel(value) {
  const preset =
    getCustomFunctionPresetById(value) ||
    getCustomFunctionPresetByFilename(value);
  return preset?.label || value || "";
}

export function isKnownCustomFunctionValue(value) {
  return Boolean(
    getCustomFunctionPresetById(value) ||
    getCustomFunctionPresetByFilename(value),
  );
}
